import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { trackButtonClick } from '../utils/pixel';
const bonuses = [{
  title: '1. Tarjetas de Rutinas Visuales',
  description: 'Evitá berrinches en las transiciones diarias (vestirse, comer, dormir) con estas tarjetas imprimibles que le dan seguridad a tu hijo.',
  value: '$4.990'
}, {
  title: '2. Rueda de las Emociones',
  description: 'Herramienta visual para que los niños aprendan a identificar y comunicar lo que sienten antes de explotar en un berrinche.',
  value: '$3.990'
}, {
  title: '3. Guía de Frases Salvavidas',
  description: "Un 'machete' rápido para tener a mano en la heladera con las frases exactas para usar en medio de la crisis.",
  value: '$5.990'
}, {
  title: '4. Diario de Emociones',
  description: 'Plantillas imprimibles para que tu hijo dibuje y procese lo que sintió después de un momento difícil.',
  value: '$3.990'
}, {
  title: '5. Checklist de Detonantes',
  description: 'Herramienta de observación para mamás: descubrí los patrones ocultos que causan las crisis de tu hijo.',
  value: '$2.990'
}, {
  title: '6. Cuentos Terapéuticos',
  description: '3 historias cortas para leer antes de dormir que enseñan regulación emocional de forma lúdica.',
  value: '$6.990'
}, {
  title: '7. Guía para Abuelos y Cuidadores',
  description: 'Un resumen amigable para explicarle a la familia cómo actuar frente a los berrinches sin desautorizarte.',
  value: '$4.990'
}, {
  title: '8. Meditaciones para Mamás',
  description: 'Audios cortos de 3 minutos para recuperar tu propio eje cuando sentís que vas a perder la paciencia.',
  value: '$7.990'
}, {
  title: '9. Planificador Semanal',
  description: 'Organizá las comidas, el sueño y el juego para mantener el equilibrio y prevenir el agotamiento familiar.',
  value: '$3.990'
}];
export function BonusesSection() {
  const handleCTAClick = () => {
    trackButtonClick('Bonuses CTA - Quiero el MegaKit con bonos');
  };
  return <section className="py-20 md:py-28 bg-dark-green" data-id="element-18">
      <div className="container mx-auto px-4" data-id="element-19">
        <SectionWrapper data-id="element-20">
          <div className="text-center mb-16" data-id="element-21">
            <span className="inline-block px-4 py-1.5 rounded-full bg-white/10 text-cream font-poppins text-sm font-bold tracking-widest uppercase mb-6" data-id="element-22">
              Todo esto viene incluido sin costo adicional
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-playfair font-bold text-white mb-4" data-id="element-23">
              🎁 9 Bonos Estratégicos — Siempre Incluidos
            </h2>
          </div>
        </SectionWrapper>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16 max-w-6xl mx-auto" data-id="element-24">
          {bonuses.map((bonus, index) => {
          // Extract number and title
          const parts = bonus.title.split('. ');
          const num = parts[0];
          const name = parts[1] || bonus.title;
          return <SectionWrapper key={index} delay={0.1 * (index % 3)} data-id="element-25">
                <div className="bg-white/5 border border-white/10 rounded-2xl p-8 relative overflow-hidden group hover:bg-white/10 transition-colors h-full flex flex-col" data-id="element-26">
                  <div className="absolute top-4 right-4 bg-terracotta text-white text-[10px] font-bold px-3 py-1 rounded-full uppercase tracking-wider shadow-sm" data-id="element-27">
                    GRATIS
                  </div>

                  <div className="text-gold font-poppins font-bold text-sm mb-3 uppercase tracking-wider" data-id="element-28">
                    BONO {num}
                  </div>

                  <h3 className="font-playfair text-xl font-bold text-white mb-4 leading-tight" data-id="element-29">
                    {name}
                  </h3>

                  <p className="font-poppins text-sm md:text-base text-cream/80 leading-relaxed flex-grow" data-id="element-30">
                    {bonus.description}
                  </p>

                  <div className="flex justify-between items-end mt-6 pt-5 border-t border-white/10" data-id="element-31">
                    <span className="text-xs text-cream/50 font-poppins uppercase tracking-wider" data-id="element-32">
                      Valor Normal
                    </span>
                    <span className="text-cream/40 font-poppins font-semibold line-through" data-id="element-33">
                      {bonus.value}
                    </span>
                  </div>
                </div>
              </SectionWrapper>;
        })}
        </div>

        <SectionWrapper delay={0.2} data-id="element-34">
          <div className="max-w-3xl mx-auto bg-gold/10 border border-gold/30 rounded-2xl p-8 text-center mb-12" data-id="element-35">
            <p className="font-poppins text-lg md:text-xl font-medium text-cream" data-id="element-36">
              Valor total de los bonos:{' '}
              <span className="font-bold line-through opacity-70" data-id="element-37">
                $43.910 ARS
              </span>
              <br className="md:hidden" data-id="element-38" />
              <span className="text-gold font-bold ml-2" data-id="element-39">
                → GRATIS con tu MegaKit
              </span>
            </p>
          </div>
        </SectionWrapper>

        <SectionWrapper delay={0.4} data-id="element-40">
          <div className="text-center" data-id="element-41">
            <a href="#pricing" onClick={handleCTAClick} className="inline-flex items-center justify-center gap-2 w-full md:w-auto px-10 py-5 min-h-[54px] bg-cream hover:bg-white text-dark-green font-poppins font-bold text-lg rounded-xl transition-all duration-300 shadow-[0_8px_20px_rgba(245,240,232,0.2)] hover:shadow-[0_12px_25px_rgba(245,240,232,0.3)] transform hover:-translate-y-1" data-id="element-42">
              → Sí, quiero el MegaKit con todos los bonos
            </a>
          </div>
        </SectionWrapper>
      </div>
    </section>;
}